import { Button, Modal } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React from "react";
import { addSubCategory, updateSubCategory } from "../../utils/api";
import CustomSelect from "../common/CustomSelect";
import CustomInput from "../common/Input";

const SubModal = ({ modal, setModal, newSubCategory, setNewSubCategory, id, getSubCategoriesData, update, setUpdate }) => {
  const [buttonloading, setButtonLoading] = React.useState(false);

  const createNewSubCategory = async () => {
    if (!newSubCategory.name || !newSubCategory.position)
      return notifications.show({ message: "Please fill all the fields", color: "red" });
    setButtonLoading(true);
    if (!update) {
      const [success] = await addSubCategory({ ...newSubCategory, categoryId: id });
      if (success) notifications.show({ message: "Sub Category added successfully", color: "green" });
    } else {
      const [success] = await updateSubCategory(update, newSubCategory);
      if (success) { notifications.show({ message: "Sub Category updated successfully", color: "green" }); setUpdate(null); }
    }
    getSubCategoriesData();
    setModal(false);
    setNewSubCategory({});
    setButtonLoading(false);
  };

  return (
    <Modal opened={modal} onClose={() => setModal(false)} title={update ? "Update Sub Category" : "Add New Sub Category"}>
      <div className="col" style={{ marginTop: "10px" }}>
        <CustomInput name="Sub Category Name" onChange={(e) => setNewSubCategory({ ...newSubCategory, name: e.target.value })} value={newSubCategory.name} />
        <CustomInput name="Sub Category Position" onChange={(e) => setNewSubCategory({ ...newSubCategory, position: e.target.value })} value={newSubCategory.position} />
        <CustomSelect value={newSubCategory.imageType} onChange={(e) => setNewSubCategory({ ...newSubCategory, imageType: e })}
          name="Select imageType" options={[{ label: "Vertical", value: "Vertical" }, { label: "Horizontal", value: "Horizontal" }]} />
        <Button onClick={createNewSubCategory} loading={buttonloading}>{update ? "Update" : "Add"}</Button>
      </div>
    </Modal>
  );
};

export default SubModal;
